/**
 * Shared parsing for GET /club/cashier/club/:clubId/cashiers responses.
 */

export function asClubCashiersList(raw, depth = 0) {
  if (raw == null || depth > 6) return [];
  if (Array.isArray(raw)) return raw;
  if (typeof raw !== "object") return [];

  const arrayKeys = [
    "cashiers",
    "items",
    "result",
    "results",
    "rows",
    "list",
    "users",
    "staff",
    "records",
    "data",
  ];
  for (let i = 0; i < arrayKeys.length; i += 1) {
    const v = raw[arrayKeys[i]];
    if (Array.isArray(v)) return v;
  }

  if (raw.data != null && typeof raw.data === "object") {
    const nested = asClubCashiersList(raw.data, depth + 1);
    if (nested.length > 0) return nested;
  }

  return [];
}

function pickCashierNamePart(r, key) {
  if (!r || typeof r !== "object") return "";
  const fromUser =
    r.user && typeof r.user === "object" ? r.user[key] : undefined;
  const v = r[key] ?? fromUser;
  return v != null && v !== "" ? String(v).trim() : "";
}

/** Display name from fullname, or firstname + lastname, else legacy name. */
export function formatClubCashierDisplayName(r) {
  const full = String(r?.fullname ?? r?.user?.fullname ?? "").trim();
  if (full) return full;
  const first = pickCashierNamePart(r, "firstname");
  const last = pickCashierNamePart(r, "lastname");
  if (first || last) return [first, last].filter(Boolean).join(" ");
  return String(r?.name ?? r?.user?.name ?? "").trim();
}

export function pickClubCashierEmpref(r) {
  if (!r || typeof r !== "object") return "";
  const v = r.empref ?? r.empRef ?? r.emp_ref;
  if (v != null && String(v).trim() !== "") return String(v).trim();
  const u = r.user;
  if (u && typeof u === "object") {
    const fromUser = u.empref ?? u.empRef ?? u.emp_ref;
    if (fromUser != null && String(fromUser).trim() !== "") {
      return String(fromUser).trim();
    }
  }
  return "";
}

export function pickClubCashierAccountStatus(r) {
  if (!r || typeof r !== "object") return "";
  return String(r.status ?? r.user?.status ?? "").trim();
}
